import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlumnosGrupoService {

  allURL = environment.apiURL+'sgc/alumnos_grupo';

  constructor(private http:HttpClient) { }

  //AlumnosGrupo
  getAllAlumnosGrupo(): Observable<any>{
    const url = this.allURL;
    return this.http.get<any[]>(url);
   }

}
